import { api } from "../utils/AuthManager";
const GetAllFacilities = async () => {
  return api
    .get(`/api/facility/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAllFacilities;
